var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M7.30762 15.2036H7.80762V14.9681L7.62601 14.8181L7.30762 15.2036ZM8.10762 18.939L8.40762 19.339L8.40762 19.339L8.10762 18.939ZM11.1576 16.6515L11.1722 16.1517L10.9975 16.1466L10.8576 16.2515L11.1576 16.6515ZM5.5 10.3081C5.5 7.07933 8.11741 4.46191 11.3462 4.46191V3.46191C7.56513 3.46191 4.5 6.52704 4.5 10.3081H5.5ZM7.62601 14.8181C6.32671 13.745 5.5 12.1233 5.5 10.3081H4.5C4.5 12.4342 5.46976 14.3342 6.98922 15.5891L7.62601 14.8181ZM7.80762 18.539V15.2036H6.80762V18.539H7.80762ZM7.80762 18.539H7.80762H6.80762C6.80762 19.363 7.74838 19.8334 8.40762 19.339L7.80762 18.539ZM10.8576 16.2515L7.80762 18.539L8.40762 19.339L11.4576 17.0515L10.8576 16.2515ZM11.3462 16.1542C11.288 16.1542 11.23 16.1534 11.1722 16.1517L11.143 17.1513C11.2105 17.1532 11.2782 17.1542 11.3462 17.1542V16.1542ZM13.6538 16.1542H11.3462V17.1542H13.6538V16.1542ZM19.5 10.3081C19.5 13.5368 16.8826 16.1542 13.6538 16.1542V17.1542C17.4349 17.1542 20.5 14.0891 20.5 10.3081H19.5ZM13.6538 4.46191C16.8826 4.46191 19.5 7.07933 19.5 10.3081H20.5C20.5 6.52704 17.4349 3.46191 13.6538 3.46191V4.46191ZM11.3462 4.46191H13.6538V3.46191H11.3462V4.46191Z",
    fill: "#999999"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.c7d87a639fd79f3b4a6795fa98a0e71b.svg";
export { ForwardRef as ReactComponent };